import React, { useState } from "react";
import { createLead } from "./api";

// Funzione per convertire data da "GG/MM" a formato ISO "YYYY-MM-DD"
const parseDataScadenza = (data) => {
  if (!data) return null;

  // Se la data viene da un input tipo "2025-04-28", la lasciamo così
  if (data.includes("-")) {
    return new Date(data).toISOString();
  }

  // Se la data è tipo "28/04" (da CSV), la trasformiamo
  const [giorno, mese] = data.split("/");
  const anno = new Date().getFullYear();

  const isoString = new Date(`${anno}-${mese}-${giorno}`).toISOString();
  return isoString;
};

const AddLeadModal = ({ onClose, onLeadAdded }) => {
  const [nome, setNome] = useState("");
  const [telefono, setTelefono] = useState("");
  const [email, setEmail] = useState("");
  const [note, setNote] = useState("");
  const [dataScadenza, setDataScadenza] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newLead = {
      nome,
      telefono,
      email,
      note,
      stato: "Lead",
      data_scadenza: parseDataScadenza(dataScadenza),
      tag: [],
      storico_modifiche: [],
    };

    await createLead(newLead);
    onLeadAdded();
    onClose();
    
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
      <div className="bg-white p-6 rounded-xl shadow-xl w-96">
        <h2 className="text-xl font-bold mb-4">Aggiungi Nuovo Lead</h2>
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <input
            className="p-2 border rounded"
            type="text"
            placeholder="Nome"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            required
          />
          <input
            className="p-2 border rounded"
            type="text"
            placeholder="Telefono"
            value={telefono}
            onChange={(e) => setTelefono(e.target.value)}
            required
          />
          <input
            className="p-2 border rounded"
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            className="p-2 border rounded"
            type="date"
            value={dataScadenza}
            onChange={(e) => setDataScadenza(e.target.value)}
          />
          <textarea
            className="p-2 border rounded"
            placeholder="Note"
            value={note}
            onChange={(e) => setNote(e.target.value)}
          />
          <div className="flex justify-end gap-2">
            <button
              type="button"
              onClick={onClose}
              className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-600"
            >
              Annulla
            </button>
            <button
              type="submit"
              className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
            >
              Salva
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddLeadModal;
